import React, { FC, useState, ChangeEvent } from 'react';
import { makeStyles, Container, TextField } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  navSpace: {
    marginTop: 32,
  },
}));

type InputStateType = {
  userName: string;
  note: string;
};

const SharedHandleChange: FC = () => {
  const classes = useStyles();
  const initialInputState: InputStateType = { userName: '', note: '' };
  const [eachInput, setEachInput] = useState(initialInputState);
  const { userName, note } = eachInput;

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target) {
      setEachInput({ ...eachInput, [e.target.name]: e.target.value });
    }
  };

  return (
    <Container maxWidth="md" className={classes.navSpace}>
      <form className={classes.root} noValidate autoComplete="off">
        <TextField
          label="User Name"
          name="userName"
          onChange={handleInputChange}
        />
        <TextField
          multiline
          rows="4"
          label="Note"
          name="note"
          onChange={handleInputChange}
        />
      </form>
      <div>userName: {userName}</div>
      <div>note: {note}</div>
    </Container>
  );
};

export default SharedHandleChange;
